/* eslint-disable no-empty */
import { EDITOR_REDUCER_NAME, CHOICE_KEYS } from './Constants';

const useEditor = ({ [EDITOR_REDUCER_NAME]: editor }) => editor;

const usePageElements = ({ [EDITOR_REDUCER_NAME]: { processes } }) =>
  processes.map(({ processId, text }) => ({ pageId: processId, pageText: text }));

const useItemNames = ({ [EDITOR_REDUCER_NAME]: { processes } }) =>
  processes.reduce((items, { choices }) => {
    choices.forEach(({ results }) => {
      results.forEach(({ store, storeHidden }) => {
        if (store || storeHidden) {
          const allItems = [...store, ...storeHidden];

          allItems.forEach(({ name }) => {
            if (!items.includes(name)) {
              items.push(name);
            }
          });
        }
      });
    });

    return items;
  }, []);

const useItemNamesByType =
  type =>
  ({ [EDITOR_REDUCER_NAME]: { processes } }) =>
    processes.reduce((items, { choices }) => {
      choices
        .flatMap(choice => choice.results)
        .filter(result => result[type])
        .flatMap(result => result[type])
        .map(result => result.name)
        .filter(name => !items.includes(name))
        .forEach(name => items.push(name));

      return items;
    }, []);

const useProcessIdsByItemName = ({ [EDITOR_REDUCER_NAME]: { processes } }) =>
  processes.reduce((acc, { processId, choices }) => {
    choices.forEach(({ results }) => {
      results.forEach(({ store, storeHidden }) => {
        if (store || storeHidden) {
          const allItems = [...store, ...storeHidden];

          allItems.forEach(({ name: itemName }) => {
            const key = acc[itemName];

            if (!key) {
              acc[itemName] = [processId];
            } else if (!acc[itemName].includes(processId)) {
              acc[itemName].push(processId);
            }
          });
        }
      });
    });

    return acc;
  }, {});

const useProcessKeysByAchievementId = ({ [EDITOR_REDUCER_NAME]: { processes } }) =>
  processes.reduce((acc, { processId, choices }) => {
    choices.forEach(({ results, choiceId }) => {
      results.forEach(({ resultId, newAchievementId }) => {
        const key = newAchievementId?.toString();

        if (key) {
          acc[key] = {
            processId,
            choiceId,
            resultId,
          };
        }
      });
    });

    return acc;
  }, {});

const useProcessIdsByValidationPassed = ({ [EDITOR_REDUCER_NAME]: { processes } }) =>
  processes.reduce((acc, { processId, text: processText, isEventFinish, choices }) => {
    if (!processText || (!isEventFinish && !choices.length)) {
      return acc;
    }

    if (isEventFinish) {
      acc.push(processId);
    } else {
      choices.filter(({ text: choiceText }) => choiceText).forEach(() => acc.push(processId));
    }

    return acc;
  }, []);

const usePropertyTextByType =
  (type, processId, choiceId, resultId) =>
  ({ [EDITOR_REDUCER_NAME]: { processes } }) => {
    const isChoiceProperty =
      type === CHOICE_KEYS.HIDE || type === CHOICE_KEYS.REQUIRED || type === CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE;

    if (isChoiceProperty) {
      return processes[processId].choices[choiceId].choicePropertyChipState[type];
    }

    const processesResults = processes[processId].choices[choiceId].results;
    const findData = processesResults.find(v => v.resultId === resultId);
    return findData.resultPropertyChipState[type];
  };

const useHilightProcess = ({ [EDITOR_REDUCER_NAME]: hilightProcess }) => hilightProcess;

const useSelectedProcessId = ({ [EDITOR_REDUCER_NAME]: selectedProcessId }) => selectedProcessId;

export {
  useEditor,
  usePageElements,
  useItemNames,
  useItemNamesByType,
  useProcessIdsByItemName,
  useProcessKeysByAchievementId,
  useProcessIdsByValidationPassed,
  usePropertyTextByType,
  useHilightProcess,
  useSelectedProcessId,
};
